/** Canonical Railway API (project passionate-laughter, service proyectopulsemusic). */
export const CANONICAL_BACKEND_URL = 'https://proyectopulsemusic-production.up.railway.app';

const normalizeBase = (value = '') => {
  const raw = `${value || ''}`.trim();
  return raw ? raw.replace(/\/+$/, '') : '';
};

const sanitizeEnvUrl = (value) => {
  if (value === undefined || value === null) return '';
  const s = String(value).trim();
  if (!s || s === 'undefined' || s === 'null') return '';
  return s;
};

const inferBackendFromWindow = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  // Optional runtime override (e.g. injected by hosting platform).
  const runtimeUrl = normalizeBase(window.__PULSE_BACKEND_URL || '');
  if (runtimeUrl) {
    return runtimeUrl;
  }
  // Same-origin relative API (Vercel rewrites /api → Railway when configured at build time).
  return '';
};

/**
 * Base URL for API calls (no trailing slash).
 * - Prefer REACT_APP_BACKEND_URL when set at build time (explicit backend host).
 * - Otherwise use same origin + relative paths so /api/* can be proxied by the static host.
 * - In production, if env is missing or invalid (e.g. literal "undefined"), fall back to
 *   CANONICAL_BACKEND_URL so fetch() never becomes `${undefined}/api/...`.
 */
export const getApiBase = () => {
  const configured = normalizeBase(sanitizeEnvUrl(process.env.REACT_APP_BACKEND_URL));
  if (configured) return configured;
  const inferred = normalizeBase(inferBackendFromWindow());
  if (inferred) return inferred;
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
    return normalizeBase(CANONICAL_BACKEND_URL);
  }
  return '';
};

export const API_BASE = getApiBase();
